




































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { Warning, WarningElementType } from './apiTypes';
import { defaultTableConfig } from '@/core/components/table';
import tableConfig from './tableConfig';
import { localize } from '@/core/filters';

@Component({
    components: {
        DxDataGrid,
        DxColumn
    }
})
export default class WarningsDetailTable extends Vue {
    @Prop({ type: Array, required: true }) public warnings!: Warning[];
    @Prop({ type: String, required: true }) public type!: WarningElementType;
    @Prop({ type: String, required: true }) public caption!: string;

    public get isClassWarnings() {
        return this.type === WarningElementType.Class;
    }

    public get isObjectWarnings() {
        return this.type === WarningElementType.Object;
    }

    public get tableConfig() {
        return {
            ...defaultTableConfig(this),
            ...tableConfig
        };
    }

    public localize = localize;
}
